import Axios from "../../src/helpers/axios";

export const getAllCountries = () => {
  return Axios.get("/api/ecommerce/v1/countries");
};

export const getProvinces = () => {
  return Axios.get("/api/ecommerce/v1/countries/provinces");
};

export const getCities = (provinceId) => {
  return Axios.get(`/api/ecommerce/v1/countries/cities/${provinceId}`);
};

export const getDistricts = (cityId) => {
  return Axios.get(`/api/ecommerce/v1/countries/districts/${cityId}`);
};

export const getSubDistricts = (districtId) => {
  return Axios.get(`/api/ecommerce/v1/countries/subdistricts/${districtId}`);
};

export const getDetailProvince = (provinceId) => {
  return Axios.get(
    `/api/ecommerce/v1/countries/provinces/details/${provinceId}`
  );
};

export const getDetailCity = (provinceId, cityId) => {
  return Axios.get(`/api/ecommerce/v1/countries/cities/details/${cityId}/province/${provinceId}`);
};

export const getDetailDistrict = (cityId, districtId) => {
  return Axios.get(`/api/ecommerce/v1/countries/districts/details/${districtId}/city/${cityId}`);
};

export const getDetailSubDistrict = (districtId, subDistrictId) => {
  return Axios.get(`/api/ecommerce/v1/countries/subdistricts/details/${subDistrictId}/district/${districtId}`);
};
